import { ReactNode } from 'react';

interface DetailMetaRowProps {
  label: string;
  value: ReactNode;
}

export function DetailMetaRow({ label, value }: DetailMetaRowProps) {
  return (
    <div className="grid grid-cols-2 gap-4 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium break-all">{value}</span>
    </div>
  );
}
